export function shortVersionId(id: string | null | undefined): string {
  if (!id) return '—'
  return String(id).replace(/-/g, '').slice(0, 8)
}

export function formatCiteTime(iso: string | null | undefined): string {
  if (!iso) return ''
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return String(iso)
  return d.toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })
}

export function cashAnswerCiteLine(opts: {
  versionId?: string | null
  computedAt?: string | null
}): string {
  const id = shortVersionId(opts.versionId)
  const time = formatCiteTime(opts.computedAt)
  return time
    ? `Answer from Cash Report · v${id} · ${time}`
    : `Answer from Cash Report · v${id}`
}

export function versionsDiffer(
  answerVersionId: string | null | undefined,
  pageVersionId: string | null | undefined,
): boolean {
  if (!answerVersionId || !pageVersionId) return false
  return String(answerVersionId) !== String(pageVersionId)
}
